import React from "react"
import { ButtonWrapper } from "./ButtonWrapper"
import Label from "./Label"

export interface ContactInfoProps {
  text: {
    title: string
    email: string
    phone: string
    address1: string
    address2: string
    address3: string
  }
}

const ContactInfo: React.FC<ContactInfoProps> = ({ text }) => {
  return (
    <div className="flex flex-col justify-center items-center">
      <div className="my-4 pr-5 text-nowrap text-gray-700">{text.title}</div>
      <ButtonWrapper
        key={`${text.email}-button`}
        onClick={() => (window.location.href = `mailto:${text.email}`)}
        styleOverrides="p-0 underline decoration-link-blue bg-transparent"
      >
        <Label
          styleOverrides="mb-4 text-link-blue"
          text={text.email}
          htmlFor={text.email}
        />
      </ButtonWrapper>
      <Label
        styleOverrides="mb-4 text-gray-700"
        text={text.phone}
        htmlFor={text.phone}
      />
      <Label
        styleOverrides="text-gray-700 text-sm"
        text="Health Advocate"
        htmlFor="Health Advocate"
      />
      <Label
        styleOverrides="text-gray-700 text-sm"
        text={text.address1}
        htmlFor={text.address1}
      />
      <Label
        styleOverrides="text-gray-700 text-sm"
        text={text.address2}
        htmlFor={text.address2}
      />
      <Label
        styleOverrides="text-gray-700 text-sm"
        text={text.address3}
        htmlFor={text.address3}
      />
    </div>
  )
}

export default ContactInfo
